import { HEX_2F5278, HEX_CED7E2, HEX_F2F6FA } from '@tanium/colors';
import { defineColor, defineThemeValue, Foreground3 } from '@tanium/react-theme-definition';

export const Fill = defineColor([HEX_F2F6FA, HEX_2F5278]);
export const Border = defineColor([HEX_CED7E2, HEX_2F5278]);
export const UseProvidedColorForBorder = defineThemeValue([true, false]);
export const Text = Foreground3;
